export const SEND_PROPERTIES = {
	SEND_FROM: "101",
	SEND_TO: "102",
	SEND_TIME: "103",
	SEND_SUBJECT: "104",
};
